<template>
  <div class="dataWrapper w-full flex justify-start items-start flex-col">
    <overviews-tab-header v-model="searchQuery">
      <h2 class="block text-lg font-medium">
        {{ $t('Shared with') }}
      </h2>
    </overviews-tab-header>
    <div class="w-full flex justify-start items-start flex-col">
      <overviews-loading v-if="loading"/>
      <overviews-loading-error v-else-if="loadingError"/>
      <overviews-no-results v-else-if="filteredDataBySearch?.length === 0"/>
      <template v-else-if="filteredDataBySearch?.length > 0">
        <overviews-shared-item
          v-for="share in filteredDataBySearch"
          :key="share.id"
          :share="share"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { search } from 'ss-search'
import useBcOverviewsModalStore from '@/frontapp/store/bcOverviewsModal'
import { DocumentApi, FolderApi } from '@/frontapp/test-api'

const documentApi = new DocumentApi({}, '/api/v2')
const folderApi = new FolderApi({}, '/api/v2')

export default {
  props: {
  },
  data() {
    return {
      searchQuery: null,
      loading: false,
      loadingError: false,
      data: null,
      apiHandler: null,
    }
  },
  computed: {
    ...mapStores(useBcOverviewsModalStore),
    filteredDataBySearch() {
      if (!this.searchQuery || this.searchQuery.length < 1) {
        return this.data
      }
      
      const searchedTeams = search(this.data, ['link', 'user.name', 'user.surname', 'user.email'], this.searchQuery)
      return searchedTeams
    },
  },
  methods: {
    async handleApi() {
      this.loading = true
      this.loadingError = false

      if (this.bcOverviewsModalStore.type === 'document') {
        this.apiHandler = documentApi
      } else {
        this.apiHandler = folderApi
      }
    
      try {
        const response = await this.apiHandler[this.bcOverviewsModalStore.type + 'Shareinfo'](this.bcOverviewsModalStore.id)
        this.data = response.data
      } catch (err) {
        this.loadingError = true
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.handleApi()
  },
}
</script>

<style lang="scss" scoped>
</style>
